import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TwoFactorMethod } from 'src/app/core/auth/auth.interface';

export interface TwoFactorMethodDialogData {
  phoneHint?: string;
  emailHint?: string;
  availableMethods?: TwoFactorMethod[];
  title?: string;
  message?: string;
}

export interface TwoFactorMethodResult {
  method: TwoFactorMethod;
}

@Component({
  selector: 'app-two-factor-method-dialog',
  templateUrl: './two-factor-method-dialog.component.html',
  styleUrls: ['./two-factor-method-dialog.component.scss']
})
export class TwoFactorMethodDialogComponent {
  readonly TwoFactorMethod = TwoFactorMethod;

  dialogRef = inject(MatDialogRef<TwoFactorMethodDialogComponent>);
  data = inject(MAT_DIALOG_DATA) as TwoFactorMethodDialogData;

  isMethodAvailable(method: TwoFactorMethod): boolean {
    if (!this.data.availableMethods || this.data.availableMethods.length === 0) {
      return true; // Backward compat: if not provided, show all
    }
    return this.data.availableMethods.includes(method);
  }

  selectMethod(method: TwoFactorMethod): void {
    if (!this.isMethodAvailable(method)) return;
    this.dialogRef.close({ method });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
